import { styled } from '@/styles/stitches.config';
import { ComposableStyledComponentProps } from '@/types/composable-styled-component';
import type * as Stitches from '@stitches/react';

const Root = styled('div', {
  maxWidth: '100vmin',
  maxHeight: '100vmin',
  flexGrow: '1',
  marginBlockEnd: '$7',

  '@bp4': {
    marginBlockEnd: 0,
  },
});

const Square = styled('div', {
  aspectRatio: '1 / 1',
  position: 'relative',
  minWidth: 0,
  minHeight: 0,

  '@supports not (aspect-ratio: 1 / 1)': {
    '&::before': {
      float: 'left',
      paddingBlockStart: '100%',
      content: '""',
    },

    '&::after': {
      display: 'block',
      content: '""',
      clear: 'both',
    },
  },
});

const Inside = styled('div', {
  maxHeight: '100%',
  maxWidth: '100%',

  '@supports not (aspect-ratio: 1 / 1)': {
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    width: '100%',
    height: '100%',
  },
});

export const ChartRoot = (
  props: ComposableStyledComponentProps<HTMLDivElement> & {
    children: React.ReactNode;
    rootCss?: Stitches.CSS;
  }
) => (
  <Root css={props.rootCss}>
    <Square>
      <Inside css={props.css}>{props.children}</Inside>
    </Square>
  </Root>
);

export const ChartSvg = styled('svg', {
  position: 'absolute',
  inset: 0,
});

export const ChartOverlay = styled('div', {
  position: 'absolute',
  inset: 0,
});

export const Point = styled('div', {
  position: 'absolute',
  top: 'var(--top)',
  left: 'var(--left)',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  height: 'auto',
});
